module.exports = __webpack_public_path__ + "static/img/logo-5-4.ce53cabb.png";